import { render } from "./MSAL2.vue?vue&type=template&id=b6751560"
import script from "./MSAL2.vue?vue&type=script&lang=js"
export * from "./MSAL2.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__